import {Component, OnInit, ViewChild} from '@angular/core';
import {PriorityService} from '../../services/priority.service';
import {PaginationComponent} from '../../../../../shared/components/pagination/pagination.component';
import {ModalService} from 'ngx-dynamic-modal';
import {EditPriorityComponent} from '../../modals/edit-priority/edit-priority.component';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {AuthService} from '../../../../../core/service/auth.service';

@Component({
  selector: 'app-priority-list',
  templateUrl: './priority-list.component.html',
  styleUrls: ['./priority-list.component.scss']
})
export class PriorityListComponent implements OnInit {

    loading: boolean = false;
    priorities: Array<Object> = [];
    tableSearchText: string = '';
    temp: Array<Object> = [];

    startAt: number = 0;
    endAt: number = 0;
    perPage: number = 10;

    @ViewChild(PaginationComponent) pagination: PaginationComponent;

    constructor(private priorityService: PriorityService, private modalService: ModalService, private alerts: AlertaService, private auth: AuthService) {

    }

    haveToPaginate(): boolean {
        return this.perPage < this.priorities.length;
    }

    goToPage(n: number) {
        if(this.pagination){
            this.startAt = this.pagination.getStart();
            this.endAt = this.pagination.getEnd();
        }
    }

    newPriority(): void {
        this.modalService.addDynamicComponent(EditPriorityComponent, { 'type' : 'new' }, () => {
            this.ngOnInit();
        });
    }

    editPriority(row: Object): void {
        this.modalService.addDynamicComponent(EditPriorityComponent, { 'type' : 'edit' , 'object' : row}, () => { this.ngOnInit(); });
    }

    deletePriority(row: Object): void {
        this.loading = true;
        this.priorityService.deletePriority(row['pk']).subscribe(
            (r) => {
                let idx = this.priorities.findIndex( (o) => { return o['pk'] == row['pk']; });
                this.priorities.splice(idx, 1);
                this.alerts.addAlert('success', 'Removed Successfully');
                this.loading = false;
            }
        )
    }

    updateFilter(event) {
        this.tableSearchText = event.target.value.toLowerCase();
        const temp = this.temp.filter((d) => {
            return d['alias_service'].toLowerCase().indexOf(this.tableSearchText) !== -1
                || d['portal_iso'].toLowerCase().indexOf(this.tableSearchText) !== -1
                || d['campaign_name'].toLowerCase().indexOf(this.tableSearchText) !== -1
                || d['text'].toLowerCase().indexOf(this.tableSearchText) !== -1
                || !this.tableSearchText;
        });

        this.priorities = temp;
    }

    ngOnInit() {
        this.loading = true;
        this.priorityService.getPriorities(this.auth.getPkPortal()).subscribe(
            (r) => {
                this.priorities = r;
                this.temp = [...r];
                this.endAt = (!this.haveToPaginate()) ? this.priorities.length : this.perPage;
                this.loading = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/priorities/components/priority-list/priority-list.component.ts